// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export const safeInvoke = (fn, ...args) => {
    if (typeof fn === 'function') {
        fn(...args);
    }
};

export const wrapFunction = (fn, wrapper) => (
    (...args) => {
        safeInvoke(fn, ...args);
        safeInvoke(wrapper, ...args);
    }
);



// WEBPACK FOOTER //
// ./components/utils.js